import { useEffect } from 'react';
import styled from 'styled-components';

import useScrollLock from '@r1-frontend/shared/hooks/useScrollLock';

const Overlay = ({ ...props }): JSX.Element => {
    const { lockScroll, unlockScroll } = useScrollLock();

    useEffect(() => {
        lockScroll();
        return unlockScroll;
    });

    return <div {...props} />;
};

export default styled(Overlay)`
    display: block;
    cursor: pointer;

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;

    background: rgba(0, 0, 0, .5);
    opacity: 0.5;
`;
